import moduleConfig from '../module.json';
import { hasSportHubLeagueModuleEnabled } from '../utils/moduleAccess.js';

const MENU_COMPONENTS = ['Clienti', 'Prenotazioni', 'Staff', 'Shop', 'Settings'];

const withoutModuleOptions = ({ module, ...item }) => item;

const findRoute = (secondaryRoutes, componentId) =>
  secondaryRoutes.find((item) => item.component?.id === componentId);

export const buildSportHubNavigation = ({
  secondaryRoutes = moduleConfig.routes.my.secondary,
  accessScope,
  user,
}) => {
  const routes = MENU_COMPONENTS.map((componentId) =>
    findRoute(secondaryRoutes, componentId)
  ).filter(Boolean);
  const routeByComponent = Object.fromEntries(
    routes.map((item) => {
      const normalizedItem = withoutModuleOptions(item);

      if (item.component.id !== 'Shop') return [item.component.id, normalizedItem];

      return [
        item.component.id,
        {
          ...normalizedItem,
          routes: {
            ...normalizedItem.routes,
            icon: { ...normalizedItem.routes?.icon, fontawesome: 'faStore' },
          },
        },
      ];
    })
  );
  const navigation = [
    routeByComponent.Clienti,
    routeByComponent.Prenotazioni,
    routeByComponent.Staff,
  ];

  if (accessScope?.sportHubShopEnabled === true) navigation.push(routeByComponent.Shop);
  if (accessScope?.sportHubDataExportEnabled === true) navigation.push(routeByComponent.Settings);
  if (hasSportHubLeagueModuleEnabled(user)) {
    navigation.push({
      component: { id: 'SportHubLeague' },
      routes: { to: '/sport-hub-league', icon: { fontawesome: 'faTrophy' } },
    });
  }

  return navigation.filter(Boolean);
};

export default buildSportHubNavigation;
